import { UserIdData, UserIdDataDto } from '$domain/model/user/user.model'

export const changeRecoveredPasswordFormToModel = (passwords, token: string) => {
  return { token, ...passwords }
}

export const mapUserIdData = (userData: UserIdDataDto): UserIdData => {
  return {
    id: userData.id ? userData.id : '',
    name: userData.name ? userData.name : '',
    email: userData.email ? userData.email : '',
    hasActivePremiumSubscription: userData.hasActivePremiumSubscription ? userData.hasActivePremiumSubscription : false,
    hasActiveProSubscription: userData.hasActiveProSubscription ? userData.hasActiveProSubscription : false,
    caretakerId: userData.caretakerId ? userData.caretakerId : '',
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/user/user.mapper.ts